import { render, staticRenderFns } from "./ListSearch.vue?vue&type=template&id=228b14a6&scoped=true"
import script from "./ListSearch.vue?vue&type=script&lang=js"
export * from "./ListSearch.vue?vue&type=script&lang=js"
import style0 from "./ListSearch.vue?vue&type=style&index=0&id=228b14a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228b14a6",
  null
  
)

export default component.exports